// extracted by mini-css-extract-plugin
export var button = "_ad-0";
export var icon = "_ad-1";